<mat-checkbox
  [checked]="checked"
  [disabled]="disabled"
  [indeterminate]="indeterminate"
  [id]="id"
  (change)="handleChange($event)"
  [class]="'level-checkbox lvl-' + level"
  [class.level-checkbox--disabled]="disabled"
  ><ng-content></ng-content
></mat-checkbox>
